<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息---{{detailObject.status==1?'报名中':detailObject.status==2?'进行中':'已结束'}}</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="培训名称">{{detailObject.name}}</el-descriptions-item>
				<el-descriptions-item label="培训分类">{{detailObject.train_cate_name}}</el-descriptions-item>
				<el-descriptions-item
					label="培训时间">{{detailObject.begin_time}}~{{detailObject.end_time}}</el-descriptions-item>
				<el-descriptions-item
					label="报名时间">{{detailObject.sign_begin_time}}~{{detailObject.sign_end_time}}</el-descriptions-item>
				<el-descriptions-item label="培训地点">{{detailObject.address}}</el-descriptions-item>
				<el-descriptions-item label="最低报名会员等级">{{detailObject.member_name}}</el-descriptions-item>
				<el-descriptions-item
					label="支持支付方式">{{detailObject.pay_type==2?'微信支付':detailObject.pay_type==1?'积分':'免费'}}</el-descriptions-item>
				<el-descriptions-item label="微信报名价格">{{detailObject.price}}</el-descriptions-item>
				<el-descriptions-item label="积分报名价格">{{detailObject.is_get_score}}</el-descriptions-item>
				<el-descriptions-item label="奖励积分">{{detailObject.get_score}}</el-descriptions-item>
				<el-descriptions-item label="取消报名电话">{{detailObject.cancel_phone}}</el-descriptions-item>
				<el-descriptions-item label="权重">{{detailObject.weight}}</el-descriptions-item>
				<el-descriptions-item label="培训封面">
					<img v-if="detailObject.img" class="pointer"
						@click="viewImage(detailObject.img.indexOf('http')!=-1? detailObject.img:imgDomain+detailObject.img)"
						:src="detailObject.img.indexOf('http')!=-1? detailObject.img:imgDomain+detailObject.img"
						style="width: 80px;height: 80px;border-radius:5px;" />
				</el-descriptions-item>
				<el-descriptions-item label="培训详情">
					<div v-html="detailObject.desc"></div>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>报名人数</h4>
			</div>
			<div class="flex" style="margin-bottom: 20px;">
				<el-button type="primary" @click="exportData">导出</el-button>
				<div style="margin-left: 20px;font-size: 14px;font-weight: 600;">报名人数/剩余名额 <span
						style="color: #ff0000;font-size: 16px;font-weight: 600;">{{bmCount}}/{{detailObject.num}}</span>
				</div>
			</div>
			<el-table border class="table-wrap" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
				:data="tableData" style="width: 100%">
				<el-table-column prop="user_uuid" label="用户ID" align="center">
				</el-table-column>
				<el-table-column prop="user_name" label="用户昵称" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="用户手机号" align="center">
				</el-table-column>
				<el-table-column prop="business" label="用户企业" align="center">
				</el-table-column>
				<el-table-column prop="member_name" label="用户会员等级" align="center">
				</el-table-column>
				<el-table-column prop="user_name" label="真实姓名" align="center">
				</el-table-column>
				<el-table-column prop="address" label="操作" align="center">
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="deleteClick(scope.row)">取消报名</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-card>


		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="goBack">返回</el-button>
			<el-button type="primary" style="width: 150px;" v-if="detailObject.status !=3"
				@click="goBack">结束培训</el-button>
		</el-card>

		<PriviewImgVue :previewImg="previewImg"></PriviewImgVue>
	</div>
</template>

<script>
	import XLSX from 'xlsx'
	import PriviewImgVue from '@/components/PriviewImg.vue';
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		addTrain,
		updateTrain,
		getTrainDetail,
		getTrainCateList
	} from "@/api/train"
	import {
		getTrainOrderList,
		deleteTrainOrderDetail
	} from "@/api/orders"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				tableData: [],
				previewImg: {
					popup: false,
					index: 0,
					imgList: []
				},
				bmCount: 0,
				uuid: ''
			};
		},
		components: {
			CommonPagination,
			PriviewImgVue
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			if (uuid) {
				this.uuid = uuid
				this.getTrainDetail(uuid);
				this.getTrainOrderList(uuid)
			}
		},
		methods: {
			exportData() {
				const headers = ['用户ID', '用户昵称', '用户手机号', '用户企业', '用户会员等级', '真实姓名']
				const data = this.tableData.map(item => [item.user_uuid, item.user_name, item.phone, item.business, item
					.member_name, item.user_name
				])
				const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
				const workbook = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
				XLSX.writeFile(workbook, '培训记录.xlsx')
			},
			deleteClick(item) {
				this.$alert('确认要取消报名吗？', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						console.log(action)
						if (action == 'confirm') {
							this.deleteClickApi(item)
						}
					}
				});
			},
			async deleteClickApi(item) {
				const {
					status,
					data
				} = await deleteTrainOrderDetail({
					uuid: item.uuid
				});
				if (status !== 200) return;
				this.$message.success('取消成功')
				this.getTrainOrderList(this.uuid)
			},
			async getTrainOrderList(uuid) {
				let postData = {
					page_size: 9999,
					page_index: 1,
					train_uuid: uuid,
					order_status: '1,2'
				};
				const {
					status,
					data
				} = await getTrainOrderList(postData);
				if (status !== 200) return;
				this.tableData = data.result.data;
				this.bmCount = data.result.total
			},
			viewImage(url) {
				this.previewImg.imgList = []
				this.previewImg.imgList.push(url)
				this.previewImg.popup = true
			},
			editorInput(e) {
				this.ruleForm.desc = e
			},
			imageUpload(e) {
				this.ruleForm.img = imgDomain + e[0]
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.ruleForm.uuid) {
							this.addTrain()
						} else {
							this.updateTrain()
						}
					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			async getTrainCateList() {
				let postData = {
					page_size: 9999,
					page_index: 1
				};
				const {
					status,
					data
				} = await getTrainCateList(postData);
				if (status !== 200) return;
				this.level = data.result.data;
			},
			async getMemberList() {
				let postData = {
					page_size: 9999,
					page_index: 1
				};
				const {
					status,
					data
				} = await getMemberList(postData);
				if (status !== 200) return;
				this.members = data.result.data;
			},
			async addTrain() {
				const {
					status,
					data
				} = await addTrain({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('新增成功')
				this.goBack()
			},
			async updateTrain() {
				const {
					status,
					data
				} = await updateTrain({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('修改成功')
				this.goBack()
			},
			goBack() {
				this.$router.go(-1)
			},
			async getTrainDetail(uuid) {
				const {
					data,
					status
				} = await getTrainDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>